<template>
  <main id="home">
    <hero />
    <value/>
    <laboratory/>
    <labelling/>
    <opportunity/>
    <future/>
		<disclaimer/>
  </main>
</template>

<style lang="scss" scoped>
  @import '../styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import Hero from '@/components/hero.vue';
import Value from '@/components/value.vue';
import Laboratory from '@/components/laboratory.vue';
import Labelling from '@/components/labelling.vue';
import Opportunity from '@/components/opportunity.vue';
import Future from '@/components/future.vue';
import Disclaimer from '../components/disclaimer.vue';

export default {
  name: 'Home',
  data() {
    return {
    };
  },
  components: {
    Hero,
    Value,
		Laboratory,
		Labelling,
		Opportunity,
    Future,
		Disclaimer
  },
};
</script>
